import { render, staticRenderFns } from "./FooterBlock.vue?vue&type=template&id=f84b29d0&scoped=true&"
import script from "./FooterBlock.vue?vue&type=script&lang=js&"
export * from "./FooterBlock.vue?vue&type=script&lang=js&"
import style0 from "./FooterBlock.vue?vue&type=style&index=0&id=f84b29d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84b29d0",
  null
  
)

export default component.exports